import React from "react";
import About from "./screens/About";
import DrugAdminScreen from "./screens/DrugAdminScreen";
import { ReactNotifications } from "react-notifications-component";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Container } from "react-bootstrap";

import RegisterScreen from "./screens/RegisterScreen";
import UserProfileScreen from "./screens/UserProfileScreen";

import PatientListScreen from "./screens/PatientListScreen";

import ClinicListScreen from "./screens/ClinicListScreen";
import ClinicScreen from "./screens/ClinicScreen";
import ClinicEditScreen from "./screens/ClinicEditScreen";

import HomeScreen from "./screens/HomeScreen";
import PriceScreen from "./screens/PriceScreen";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ErrScreen from "./screens/ErrScreen";

import LoginScreen from "./screens/LoginScreen";
import VisitListScreen from "./screens/VisitListScreen";
import PatientScreen from "./screens/PatientScreen";
import Test from "./screens/Test";
import PasswordRecoveryScreen from "./screens/PasswordRecoveryScreen";

const App = () => {
  return (
    <>
      <ReactNotifications />
      <Router>
        <Header />
        <main className="py-3">
          <Container>
            <Routes>
              <Route path="/register-screen" element={<RegisterScreen />} />
              <Route path="/login-screen" element={<LoginScreen />} />

              <Route path="/profile" element={<UserProfileScreen />} />
              <Route path="/test" element={<Test />} />

              <Route
                path="/clinic-list-screen"
                element={<ClinicListScreen />}
              />
              <Route
                path="/clinic-screen/:clinicId"
                element={<ClinicScreen />}
              />
              <Route
                path="/clinic-edit-screen/:clinicId"
                element={<ClinicEditScreen />}
              />

              <Route
                path="/patient-list-screen/:clinicOwnerId"
                element={<PatientListScreen />}
              />

              <Route
                path="/patient-screen/:patientId"
                element={<PatientScreen />}
              />
              <Route
                path="/visit-list-screen/:clinicId"
                element={<VisitListScreen />}
              />

              <Route
                path="/Password-Recovery-Screen/:userId"
                element={<PasswordRecoveryScreen />}
              />

              <Route path="/" element={<HomeScreen />} />

              <Route path="/price-screen" element={<PriceScreen />} />

              <Route path="/drugs" element={<DrugAdminScreen />} />

              <Route path="/برنامج-العيادة" element={<About />} />

              <Route path="/*" element={<ErrScreen />} />
            </Routes>
          </Container>
        </main>
        <Footer />
      </Router>
    </>
  );
};

export default App;
